import { CloseButton, Heading, TextLabel, Box } from '@customerio/pluma-components/react';
import * as styles from './index.css';

interface PlainHeaderProps {
  title: string;
  label: string;
  onClose: () => void;
}

export function RocketPlainHeader({ title, label, onClose }: PlainHeaderProps) {
  return (
    <Box as="header" px="250" py="150" pt="350">
      <TextLabel mb="050">{label}</TextLabel>
      <Heading level="3">{title}</Heading>
      <CloseButton onClick={onClose} className={styles.contentCloseButton} />
    </Box>
  );
}
